<template>
  <router-view />
</template>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background: #0a0f1e;
  color: #fff;
  overflow-x: hidden;
}

#app {
  min-height: 100vh;
  background: linear-gradient(180deg, #0a0f1e 0%, #101933 50%, #0a0f1e 100%);
}

/* 滚动条样式 */
::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}

::-webkit-scrollbar-track {
  background: rgba(15, 23, 42, 0.5);
}

::-webkit-scrollbar-thumb {
  background: linear-gradient(180deg, #667eea 0%, #764ba2 100%);
  border-radius: 5px;
  transition: background 0.3s ease;
}

::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(180deg, #8ab4f8 0%, #ba94f8 100%);
}

/* 选中文本样式 */
::selection {
  background: rgba(138, 180, 248, 0.3);
  color: #fff;
}

::-moz-selection {
  background: rgba(138, 180, 248, 0.3);
  color: #fff;
}
</style>

